/**
 * @packageDocumentation
 * @module f1/array
 */

import { I } from '../core/immutable';

type t_sort_fn<T> = (valA: T, valB: T, arr: T[]) => number;

export interface Sort {
  /**
   * Sort an array by a function
   *
   * @public
   * @function f1.sort
   * @param fn a sorting function
   * @param arr the array to sort
   * @example
   *
   * ```ts
   * f1.sort((a, b) => b.order - a.order, [{ order: 3 }, { order: 2 }]) => [{ order: 2 }, { order: 3 }]
   * ```
   *
   */
  <T>(fn: t_sort_fn<T>, arr: T[]): T[];
  <T>(fn: t_sort_fn<T>): (arr: T[]) => T[];
}

/**
 * @see Sort
 */
export default <T>(fn: t_sort_fn<T>, arr: T[]): T[] => {
  return I.array(arr).sort((a: T, b: T) => fn(a, b, arr));
};
